import type { FC } from 'react';
import type { Line } from '../copy';
import { CopyLine } from './CopyLine';

// Centred tagline block. Desktop font 28px, mobile 20px; line-height 1.3,
// slight negative letter-spacing per source mockup.
export const OnePagerHero: FC<{ hero: Line[] }> = ({ hero }) => (
  <section
    aria-label="Tagline"
    className="mx-auto mb-9 max-w-[720px] text-center md:mb-16"
    style={{ letterSpacing: '-0.005em' }}
  >
    {hero.map((line, i) => (
      <p
        key={i}
        className="m-0 text-[20px] font-normal leading-[1.3] md:text-[28px]"
      >
        <CopyLine line={line} />
      </p>
    ))}
  </section>
);
